// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"978d9c9d","498":"3b404dd3","703":"2f161fc8","787":"5e64455b"}[chunkId] + ".chunk.js";
};